function tabClick(e){9===e.keyCode&&(document.body.classList.add("js-using-tab"),window.removeEventListener("keydown",tabClick))}window.addEventListener("keydown",tabClick),window.theme??={},window.theme.wrapRteTables=(e=document)=>{e.querySelectorAll(".rte table").forEach((e=>{if(e.closest(".js-theme-utility-rte-table-wrap"))return;const t=document.createElement("div");var o,n;t.classList.add("js-theme-utility-rte-table-wrap"),t.setAttribute("style","overflow:auto;-webkit-overflow-scrolling:touch"),n=t,(o=e).parentNode.insertBefore(n,o),n.appendChild(o)}))},window.theme.wrapRteTables();const scrollEndSupported="undefined"==typeof window||"onscrollend"in window;scrollEndSupported||import("scrollyfills");
//# sourceMappingURL=global.js.map

function updateQuantityDirection() {
  const htmlLang = document.documentElement.lang;
  const quantityElements = document.querySelectorAll('quantity-input');

  quantityElements.forEach((el) => {
    el.style.display = 'flex-inline';
    el.style.flexDirection = htmlLang === 'ar' ? 'row-reverse' : 'row';
  });
}

document.addEventListener('DOMContentLoaded', () => {
  // Run once on initial load
  updateQuantityDirection();

  // Observe DOM changes for dynamically added quantity-inputs (like in cart drawer)
  const observer = new MutationObserver(() => {
    updateQuantityDirection();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

